import React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { Box, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';
import { ExitReason } from '../../../../../models';

interface FrozenAccountProps {
  id: string;
}

export default function ThinCreditFile({ id }: FrozenAccountProps) {
  const { currentSubStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.ThinCreditFile, success: false });
      }}
      render={() => (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
          <Icon size="lg" css={{ color: 'icon.neutral' }}>
            <IconRateUnhappyFilled />
          </Icon>
          <Heading level={2} textStyle="heading-sm">
            Limited or no credit history available
          </Heading>
          <Paragraph>We are unable to verify your identity because you have little or no credit history.</Paragraph>
        </Box>
      )}
    />
  );
}
